import ClipboardContainer from "../../../../components/formsAndTable/forms/formWidgets/clipboard";

const Clipboard = () => {
  return <ClipboardContainer />;
};

export default Clipboard;
